import React from 'react'
import moment from 'moment'
import Modal from './Modal'
import { ComponentContainer } from './Modal/styled'
import { Text1 } from './ui/text'
import theme from '../styled/theme'
import QuickAccessCardList from './quickAceesCard/QuickAccessCardList'
import { Aple, ChevronRight, Google, Outlook, Yahoo } from '../assets/icons'

const openExternalLink = url => {
	if (!url) return
	window.open(url, '_blank', 'noopener,noreferrer')
}

const downloadIcsFile = eventData => {
	if (!eventData?.startTime) return

	const startTime = moment(eventData.startTime)
	const endTime = eventData.endTime
		? moment(eventData.endTime)
		: moment(eventData.startTime).add(1, 'hours')
	const safeText = text => (text || '').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;')

	const icsContent = [
		'BEGIN:VCALENDAR',
		'VERSION:2.0',
		'PRODID:-//Omint//Portal//ES',
		'BEGIN:VEVENT',
		`UID:${Date.now()}@omint.com.ar`,
		`DTSTAMP:${moment().utc().format('YYYYMMDDTHHmmss[Z]')}`,
		`DTSTART:${startTime.utc().format('YYYYMMDDTHHmmss[Z]')}`,
		`DTEND:${endTime.utc().format('YYYYMMDDTHHmmss[Z]')}`,
		`SUMMARY:${safeText(eventData.title || 'Turno')}`,
		`DESCRIPTION:${safeText(eventData.description || '')}`,
		`LOCATION:${safeText(eventData.location || '')}`,
		'END:VEVENT',
		'END:VCALENDAR'
	].join('\r\n')

	const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' })
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.setAttribute('download', 'turno.ics')
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	URL.revokeObjectURL(url)
}

const getCalendarLinksFromEvent = event => {
	if (!event?.startTime) {
		return {
			googleUrl: '',
			outlookUrl: '',
			outlookComUrl: '',
			yahooUrl: ''
		}
	}

	const startTime = moment(event.startTime)
	const endTime = event.endTime ? moment(event.endTime) : moment(event.startTime).add(1, 'hours')
	const title = event.title || 'Turno'
	const description = event.description || ''
	const location = event.location || ''

	const googleDates = `${startTime.utc().format('YYYYMMDDTHHmmss[Z]')}/${endTime
		.utc()
		.format('YYYYMMDDTHHmmss[Z]')}`
	const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
		title
	)}&dates=${encodeURIComponent(googleDates)}&details=${encodeURIComponent(
		description
	)}&location=${encodeURIComponent(location)}`

	const outlookUrl = `https://outlook.office.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(
		title
	)}&startdt=${encodeURIComponent(startTime.toISOString())}&enddt=${encodeURIComponent(
		endTime.toISOString()
	)}&body=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}`

	const outlookComUrl = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(
		title
	)}&startdt=${encodeURIComponent(startTime.toISOString())}&enddt=${encodeURIComponent(
		endTime.toISOString()
	)}&body=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}`

	const durationMinutes = Math.max(endTime.diff(startTime, 'minutes'), 30)
	const yahooDuration = `${String(Math.floor(durationMinutes / 60)).padStart(2, '0')}${String(
		durationMinutes % 60
	).padStart(2, '0')}`
	const yahooUrl = `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${encodeURIComponent(
		title
	)}&st=${encodeURIComponent(startTime.utc().format('YYYYMMDDTHHmmss[Z]'))}&dur=${encodeURIComponent(
		yahooDuration
	)}&desc=${encodeURIComponent(description)}&in_loc=${encodeURIComponent(location)}`

	return { googleUrl, outlookUrl, outlookComUrl, yahooUrl }
}

const AddToCalendarQuickAccessModal = ({
	isOpen,
	onClose,
	isFullHeight,
	event,
	title = 'Agregar a mi calendario'
}) => {
	if (!isOpen) return null

	const { googleUrl, outlookUrl, outlookComUrl, yahooUrl } = getCalendarLinksFromEvent(event)
	const items = [
		{
			id: 'apple-calendar',
			text: 'Apple calendar',
			leftIcon: <Aple />,
			righIcon: <ChevronRight color={theme.colors.brand.lightBlue} />,
			onClick: () => downloadIcsFile(event)
		},
		{
			id: 'google',
			text: 'Google',
			leftIcon: <Google />,
			righIcon: <ChevronRight color={theme.colors.brand.lightBlue} />,
			onClick: () => openExternalLink(googleUrl)
		},
		{
			id: 'outlook',
			text: 'Outlook',
			leftIcon: <Outlook color={theme.colors.brand.lightBlue} />,
			righIcon: <ChevronRight color={theme.colors.brand.lightBlue} />,
			onClick: () => openExternalLink(outlookUrl)
		},
		{
			id: 'outlook-com',
			text: 'Outlook.com',
			leftIcon: <Outlook color={theme.colors.brand.lightBlue} />,
			righIcon: <ChevronRight color={theme.colors.brand.lightBlue} />,
			onClick: () => openExternalLink(outlookComUrl)
		},
		{
			id: 'yahoo',
			text: 'Yahoo',
			leftIcon: <Yahoo />,
			righIcon: <ChevronRight color={theme.colors.brand.lightBlue} />,
			onClick: () => openExternalLink(yahooUrl)
		}
	]

	return (
		<Modal onClose={onClose} isFullHeight={isFullHeight}>
			<ComponentContainer isFullHeight={isFullHeight} $alignItems="flex-start" $padding="54px 20px 20px 30px">
				<Text1 color={theme.colors.text.primaryText}>{title}</Text1>
				<QuickAccessCardList items={items} />
			</ComponentContainer>
		</Modal>
	)
}

export default AddToCalendarQuickAccessModal